exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tile-solid[data-v-28dcd877]{border-left:1px solid #000;border-top:1px solid #000}", ""]);

// exports
